import {useMutation, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpStoreAccessRates, HttpStoreAccessRatesOptions} from '../http/budget.http'

export const useStoreAccessRates = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (variables: HttpStoreAccessRatesOptions) => httpStoreAccessRates(variables),
        onSuccess: async () => {
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESS_RATES]})
        }
    })
}
